var map = {
	"./annex-fr/annex1.png": 595,
	"./annex-fr/annex2.png": 596,
	"./annex-fr/annex3.png": 597,
	"./annex-fr/annex4.png": 598,
	"./annex-fr/annex5.png": 599,
	"./annex-fr/annex6.png": 600,
	"./annex/annex1.png": 601,
	"./annex/annex2.png": 602,
	"./annex/annex3.png": 603,
	"./annex/annex4.png": 604,
	"./annex/annex5.png": 605,
	"./annex/annex6.png": 606,
	"./annex1.png": 281,
	"./annex10.png": 282,
	"./annex11.png": 283,
	"./annex12.png": 284,
	"./annex13.png": 285,
	"./annex14.png": 286,
	"./annex2.png": 287,
	"./annex3.png": 288,
	"./annex4.png": 289,
	"./annex5.png": 290,
	"./annex6.png": 291,
	"./annex7.png": 292,
	"./annex8.png": 293,
	"./annex9.png": 294,
	"./copyright.png": 607,
	"./cover-light.png": 608,
	"./f0020-01.png": 295,
	"./f0020-02.png": 296,
	"./f0021-01.png": 280,
	"./favicon-16x16.png": 609,
	"./favicon-16x16_01.png": 610,
	"./favicon-32x32.png": 611,
	"./favicon-32x32_01.png": 612,
	"./fig25.png": 297,
	"./fig56.png": 298,
	"./fig57.png": 299,
	"./imac-mockup-01.png": 613,
	"./next.png": 614,
	"./poster-sdg-1.png": 278,
	"./poster-sdg-10.png": 300,
	"./poster-sdg-12.png": 301,
	"./poster-sdg-14.png": 302,
	"./poster-sdg-15.png": 303,
	"./poster-sdg-2.png": 279,
	"./poster-sdg-5.png": 304,
	"./poster-sdg-6.png": 305,
	"./prev.png": 615,
	"./reportCover.png": 616,
	"./sdg-12-load.png": 617,
	"./sdg-14-load.png": 618,
	"./sdg-15-load.png": 619,
	"./sdg-2-load.png": 620,
	"./sdg-5-load.png": 621,
	"./sdg-6-load.png": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;